var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',{staticClass:"appup-file",attrs:{"id":_vm.id,"state":_vm.state,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"accept":_vm.accept ? _vm.accept : null},on:{"change":_vm.onSelect},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/file/file.vue